// extracted by mini-css-extract-plugin
export var productCategories = "productCategories-module--productCategories--SjEtD";
export var category = "productCategories-module--category--d-yiQ";
export var buyOverlay = "productCategories-module--buyOverlay--H-1cq";
export var learnMoreCTA = "productCategories-module--learnMoreCTA--psP4u";
export var swiperSlide = "productCategories-module--swiperSlide--1eHp6";
export var sliderImage = "productCategories-module--sliderImage--i1NR9";
export var rating = "productCategories-module--rating--DliTg";
export var reviewStar = "productCategories-module--reviewStar--ifaA7";
export var categoryImage = "productCategories-module--categoryImage--aWcuj";